import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, TextareaAutosize } from "@mui/material";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const PostQueryForm: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [companyphonenumber, setCompanyPhoneNumber] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [description, setDescription] = useState<string>("");

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  // const changePageStatus = (status: boolean) => {
  //   if (status === true) {
  //     if (pageStatus < 2) {
  //       setPageStatus(pageStatus + 1);
  //     }
  //   } else {
  //     if (pageStatus > 1) {
  //       setPageStatus(pageStatus - 1);
  //     }
  //   }
  // };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      // backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        {pageStatus !== 2 ? (
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3">What's on your mind</h4>
            </Grid>
            <Grid xs={2} textAlign='end' className="mt-2">
              <GridCloseIcon
                onClick={() => {
                value_update(attrName, false);
                setDescription("");
              }}
              />
            </Grid>
            <Grid xs={12} paddingTop={0} className="mb-3">
              <hr />
            </Grid>
          </Grid>
        ) : null}
        <div className="scrollable_area mt-2">
          {pageStatus !== 2 ? (
            <Grid
              container
              spacing={2}
              justifyContent="center"
              className="mb-3"
            >
              <Grid xs={12}>
                <TextareaAutosize
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                  className="text_area"
                  aria-label="empty textarea"
                  placeholder="Description"
                />
              </Grid>
              {/* <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title={"Write your question here"}
                  value={companyphonenumber}
                  attrName={setCompanyPhoneNumber}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid> */}
            </Grid>
          ) : null}
          {pageStatus === 2 ? (
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Grid xs={12}>
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success text-center">
                  Your Query has been added successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
        </div>
        {pageStatus !== 2 ? (
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  value_update(attrName, false);
                  value_update("notes_new_data", description);
                  setDescription("");
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </SlidingPanel>
  );
};

export default PostQueryForm;
